var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask",
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": function ($event) {
        if ($event.target !== $event.currentTarget) return null;
        return _vm.onMaskClick.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "modal-wrapper",
    on: {
      "click": function ($event) {
        if ($event.target !== $event.currentTarget) return null;
        return _vm.onMaskClick.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('ThemedLoading', {
    attrs: {
      "active": _vm.isLoading,
      "is-full-page": false,
      "loader": "dots",
      "opacity": 0.6,
      "can-cancel": false
    }
  }), _c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", function () {
    return [_vm.$slots.title ? _vm._t("title") : _c('h4', [_vm._v(_vm._s(_vm.title))]), _c('button', {
      staticClass: "btn-close",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.closeModal
      }
    }, [_c('span', {
      staticClass: "fa fa-solid fa-times"
    })])];
  })], 2), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "wrapper",
    class: {
      'no-padding': _vm.noPadding
    }
  }, [_vm._t("body")], 2)]), _vm.$slots.footer ? _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer")], 2) : _vm._e()], 1)])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }